// extracted by mini-css-extract-plugin
export default {"dropZone":"input-drop-zone-DropZone__dropZone--2XjBc","isDragOver":"input-drop-zone-DropZone__isDragOver--2tkzq"};